var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { FiPlus } from "react-icons/fi";
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import * as Yup from 'yup';
import styles from './styles.module.scss';
import { Button, Table, InputSelect } from 'template/lib';
import { BsTrash } from "react-icons/bs";
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
var ModalLibraryPublisher = function (props) {
    var _a = useState(0), idToChange = _a[0], setIdToChange = _a[1];
    var _b = useState(false), saveButton = _b[0], setSaveButton = _b[1];
    var history = useHistory();
    var _c = useAuth(), login = _c.login, handleLogout = _c.handleLogout;
    var _d = useState([]), items = _d[0], setItems = _d[1];
    var _e = useState([]), itemsTable = _e[0], setItemsTable = _e[1];
    var _f = useState(1), page = _f[0], setPage = _f[1];
    var _g = useState(1), totalPages = _g[0], setTotalPages = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState(false), refresh = _j[0], setRefresh = _j[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        if (login && Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
            handleLogout();
            history.push('/');
        }
        if (!login) {
            history.push('/');
        }
    }, []);
    useEffect(function () {
        if ((itemsTable === null || itemsTable === void 0 ? void 0 : itemsTable.length) > 0) {
            //os usuários do select (items) já vem filtrados da API desconsiderando os usuários do grid (itemsTable)
            //então não precisa filtrar no javascript
            //const resultado = items.filter(item => !itemsTable.some(itemTable => itemTable.licenseNumber === item.licenseNumber));
            //setItems(resultado);
        }
    }, [itemsTable]);
    useEffect(function () {
        if (props.modalIsOpenLibraryPublisher) {
            resetFormValues();
            api.get("/libraries/potential-publishers/" + props.companyId, config)
                .then(function (response) {
                setItems(Array.isArray(response.data) ? response.data : []);
            })
                .catch(function (error) {
                console.error('Erro ao carregar usuários com licença do maker:', error);
            });
            api.get("/libraries/publishers/" + props.companyId, config)
                .then(function (response) {
                setItemsTable(Array.isArray(response.data) ? response.data : []);
            })
                .catch(function (error) {
                console.error('Erro ao carregar usuários com permissão:', error);
            })
                .finally(function () { return setLoading(false); });
        }
        else {
            setItemsTable([]);
        }
    }, [props.modalIsOpenLibraryPublisher]);
    var makerLicensesSelect = {
        label: 'Usuário',
        options: items.sort(function (a, b) {
            return a.displayToSelect.localeCompare(b.displayToSelect, "pt-BR", { sensitivity: "base" });
        })
    };
    var librarySchema = Yup.object().shape({
        licenseNumber: Yup.string().required('Por favor, informe um usuário.'),
    });
    function resetFormValues() {
        formik.resetForm({
            values: {
                licenseNumber: ''
            },
        });
    }
    var formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            licenseNumber: ''
        },
        validationSchema: librarySchema,
        onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            var itemSelect, itemSelectIndex;
            return __generator(this, function (_a) {
                try {
                    itemSelect = items.find(function (item) { return item.licenseNumber == values.licenseNumber; });
                    if (itemSelect != null && itemSelect != undefined) {
                        itemSelectIndex = items.indexOf(itemSelect);
                        items.splice(itemSelectIndex, 1);
                        itemsTable.push(itemSelect);
                        resetFormValues();
                    }
                }
                catch (err) {
                    if (!login || Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
                        handleLogout();
                        history.push('/');
                    }
                    console.log(err);
                    alert('erro');
                }
                return [2 /*return*/];
            });
        }); },
    });
    var handleRemove = function (id) {
        var itemToRemove = itemsTable.find(function (item) { return item.id == id; });
        if (itemToRemove != null && itemToRemove != undefined) {
            var indexToRemove = itemsTable.indexOf(itemToRemove);
            itemsTable.splice(indexToRemove, 1);
            items.push(itemToRemove);
            items.sort(function (a, b) {
                return a.displayToSelect.localeCompare(b.displayToSelect, "pt-BR", { sensitivity: "base" });
            });
            setRefresh(!refresh);
        }
    };
    var lineBtns = [
        {
            fn: handleRemove,
            icon: _jsx(BsTrash, { size: 15 }, void 0),
            name: 'Remover'
        }
    ];
    var handleSave = function (id) {
        setSaveButton(true);
        try {
            // ENVIAR PARA API
            var valuesPayload = (itemsTable !== null && itemsTable !== void 0 ? itemsTable : []).map(function (_a) {
                var id = _a.id, licenseNumber = _a.licenseNumber, select_is_publisher_wps = _a.select_is_publisher_wps;
                return ({
                    id: id,
                    licenseNumber: licenseNumber,
                    isPublisherWps: (select_is_publisher_wps === null || select_is_publisher_wps === void 0 ? void 0 : select_is_publisher_wps.id) == "1"
                });
            });
            console.log("valuesPayload = " + valuesPayload);
            api.post("/libraries/publishers/" + props.companyId, valuesPayload, config)
                .then(function (response) {
                props.handleCloseModalLibraryPublisher();
            })
                .catch(function (error) {
                console.error('Erro ao salvar usuários com permissão:', error);
            });
        }
        catch (err) {
            if (!login || Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
                handleLogout();
                history.push('/');
            }
            console.log(err);
            alert('erro');
        }
    };
    var tableColumns = [
        { label: 'Usuário', key: 'userDomain', disabled: true },
        { label: 'Número da licença', key: 'licenseNumber', disabled: true },
        { label: 'Detalhes', key: 'details', disabled: true },
    ];
    if ((login === null || login === void 0 ? void 0 : login.role) == "Administrator" && props.companyId == 124) {
        tableColumns.splice(3, 0, { label: 'Publisher WPS?', key: 'select_is_publisher_wps', disabled: false });
    }
    var columns = 1;
    return (_jsx("div", { children: _jsxs(Modal, __assign({ isOpen: props.modalIsOpenLibraryPublisher, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalLibraryPublisher, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Example Modal" }, { children: [_jsxs("div", __assign({ className: '' }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: ' font-semibold border-b-2 text-lg' }, { children: "Permiss\u00F5es de upload da biblioteca" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalLibraryPublisher }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsx("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: _jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-" + columns + " lg:grid-cols-" + columns + " my-2 justify-items-end" }, { children: [_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(InputSelect, { onChange: formik.handleChange, value: formik.values.licenseNumber, name: 'licenseNumber', values: makerLicensesSelect, valueMember: 'licenseNumber', displayMember: 'displayToSelect', firstOption: 'Selecione um usu\u00E1rio' }, void 0), _jsx("button", __assign({ type: "submit", style: {
                                                            border: 'none',
                                                            background: 'transparent',
                                                            paddingTop: '2px',
                                                            cursor: 'pointer'
                                                        }, title: "Adicionar usu\u00E1rio" }, { children: _jsx(FiPlus, { size: 20 }, void 0) }), void 0)] }), void 0), formik.errors.licenseNumber && formik.touched.licenseNumber && (_jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.licenseNumber }), void 0))] }), void 0) }), void 0) }), void 0) }), void 0), _jsx(Table, { page: page, data: itemsTable, setData: setItemsTable, totalPAges: totalPages, loading: loading, title: 'Usu\u00E1rios com permiss\u00E3o', refresh: setRefresh, lineButton: lineBtns, editable: true, setIdToChange: setIdToChange, hideBtnSave: true, columns: tableColumns }, void 0)] }), void 0), _jsx("br", {}, void 0), _jsx("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end' } }, { children: _jsx(Button, __assign({ type: 'submit', className: '', disabled: saveButton, onClick: handleSave }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }, void 0));
};
export default ModalLibraryPublisher;
